import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import { withStyles, TextField, MenuItem, IconButton } from "@material-ui/core";
import t from "../../../languages/pl";
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = theme => ({
    form: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "flex-start",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column"
        },
        width: "90%",
        paddingBottom: theme.spacing(1)
    },
    input: {
        margin: theme.spacing(1),
        marginLeft: 0
    },
    column1: {
        maxWidth: 300
    },
    column2: {
        maxWidth: 150
    },
    select: {
        minWidth: 100
    },
    searchButton: {
        padding: 0
    }
});

const initialState = {
    nazwa: "",
    adres: "",
    typ: ""
};

const LocationForm = forwardRef((props, ref) => {
    const { classes, data, onSave, onSearch, onChange, dataAfterSearch } = props;
    const [state, setState] = useState(initialState);

    useEffect(() => {
        if (!data)
            return;
        if (dataAfterSearch !== null) {
            setState(dataAfterSearch);
        } else {
            setState(data);
        }
    }, [data]);

    useEffect(() => {
        onChange && onChange(state);
    }, [state]);

    useEffect(() => {
        if(!ref)
            return;
        ref.current.addEventListener('save', handleSave);
        //ref.current.addEventListener('search', handleSearch);
        return () => {
            ref.current.removeEventListener('save', handleSave);
            //ref.current.removeEventListener('search', handleSearch);
        };
    }, []);

    const getFormValues = (e) => ({
            adres: e.target["adres"].value,
            nazwa: e.target["nazwa"].value,
            typ: e.target["typ"].value,
    }
    );

    const handleSave = e => onSave && onSave(getFormValues(e));
    //const handleSearch = e => onSearch && onSearch(getFormValues(e));
    const handleSearch = () => onSearch && onSearch(state);

    const handleChange = e => {
        e.persist();
        setState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));
    };

    return (
        <>
            <form
                ref={ref}
                className={classes.form}
            >
                <div className={classes.column1}>
                    <TextField
                        label={t.name}
                        className={classes.input}
                        fullWidth
                        name="nazwa"
                        value={state.nazwa}
                        onChange={handleChange}
                    />
                    <TextField
                        label={t.address}
                        className={classes.input}
                        fullWidth
                        placeholder={t.addressPlaceholder}
                        name="adres"
                        value={state.adres}
                        onChange={handleChange}
                        InputProps={
                            {
                            classes: { input: classes.inputField },
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton
                                        className={classes.searchButton}
                                        disabled={state.adres === ""}
                                        onClick={handleSearch}
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                        }}
                    />
                </div>
                <div className={classes.column2}>
                    <TextField
                        className={clsx([classes.input, classes.select])}
                        label={t.type}
                        select
                        defaultValue=""
                        name="typ"
                        value={state.typ}
                        onChange={handleChange}
                    >
                        <MenuItem value=""><em>{t.pick}</em></MenuItem>
                        <MenuItem value="Klient">{t.client}</MenuItem>
                        <MenuItem value="Dom">{t.home}</MenuItem>
                    </TextField>
                </div>
            </form>
        </>
    );
});

LocationForm.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    onSave: PropTypes.func,
    onSearch: PropTypes.func,
    onChange: PropTypes.func,
    dataAfterSearch: PropTypes.object
};

LocationForm.displayName = "LocationForm";

export default withStyles(useStyles)(LocationForm);
